import { cloneDeep } from 'lodash';
import store from '@/store/index';

export default {
  /**
   * @param el
   * @param binding {object} directive binding object, used to pass in additional custom validation with invalid, and CTA copy with elementText
   * @param vnode
   */
  bind(el, binding, vnode) {
    /**
     * @param isValid {boolean} form validation status
     */
    const route = cloneDeep(store.state.route);
    // eslint-disable-next-line no-param-reassign
    el.dataset.elementText = binding.value.elementText;
    // eslint-disable-next-line no-param-reassign
    el.dataset.invalid = binding.value.invalid;
    vnode.componentInstance.$on('onValidate', async isValid => {
      // invalid is for passing in additional custom validation
      const { elementText, invalid } = el.dataset;
      const eventActionResult = isValid === true && invalid !== 'true' ? 'open' : 'error';
      await store.dispatch('analytics/ctaInteractionEvent', {
        elementText,
        eventActionResult,
        route,
      });
    });
  },
  update(el, binding) {
    if (binding.value !== binding.oldValue) {
      // eslint-disable-next-line no-param-reassign
      el.dataset.elementText = binding.value.elementText;
      // eslint-disable-next-line no-param-reassign
      el.dataset.invalid = binding.value.invalid;
    }
  },
};
